import { Food, IngredientFood } from '../../../../core/db_food'
import { changeCustomTag } from './core'
import { FOODS_EXPORT_EXT, FOODS_EXPORT_GZ_EXT } from './coreFoodsImport'
import { encryptUtf8WithPassword } from './foodsExportCrypto'



export async function exportFoodsToFile(foods: Food[], startId: number, tag: string, exportPassword?: string) {
    let [newFoods] = updateFoodsIds(foods, startId)
    tag = tag.trim()
    if (tag.length > 0) {
        newFoods = changeCustomTag('replace', tag, newFoods)
    }
    await saveFoodsToFile(tag, newFoods, exportPassword)
}

type FoodOrIngredientFood = Food | IngredientFood

export function updateFoodsIds(foods: Food[], startId: number): [Food[], number] {
    const newFoods = foods.map(food => {
        return {
            ...food,
            mc: food.mc.map(ingredient => {
                return { ...ingredient }
            }),
        }
    })
    const currIds = getAllFoodsAsMap(newFoods)
    let ID = startId
    currIds.forEach(newFoods => {
        newFoods.forEach(food => {
            food.dt = ID
        })
        ID += 1
    })
    return [newFoods, ID]
}

export function getAllFoodsAsMap(foods: Food[]): Map<number, FoodOrIngredientFood[]> {
    const currIds = new Map<number, FoodOrIngredientFood[]>()
    const addFood = (food: FoodOrIngredientFood) => {
        if (!currIds.has(food.dt)) {
            currIds.set(food.dt, [])
        }
        currIds.get(food.dt)!.push(food)
    }
    for (const food of foods) {
        addFood(food)
        food.mc.forEach(ingredient => addFood(ingredient))
    }
    return currIds
}

async function saveFoodsToFile(tag: string, foods: Food[], exportPassword?: string) {
    if (exportPassword == null || exportPassword?.trim().length === 0) {
        exportPassword = 'default-pass'
    }
    const strFoods = JSON.stringify(foods)
    const safeTag = transliterate(tag)
    const baseName = `foods_${safeTag || 'export'}`
    const canGzip = typeof CompressionStream !== 'undefined'
    const jsonBlob = () => new Blob([strFoods], { type: 'application/json;charset=utf-8' })

    const usePassword = exportPassword != null && exportPassword.trim().length > 0
    const payloadUtf8 = usePassword
        ? await encryptUtf8WithPassword(strFoods, exportPassword.trim(), { gzipBeforeEncrypt: canGzip })
        : strFoods

    if (canGzip) {
        const gzipBlob = await gzipUtf8Text(payloadUtf8)
        triggerBlobDownload(gzipBlob, `${baseName}${FOODS_EXPORT_GZ_EXT}`)
    } else {
        const blob = usePassword
            ? new Blob([payloadUtf8], { type: 'application/json;charset=utf-8' })
            : jsonBlob()
        triggerBlobDownload(blob, `${baseName}${FOODS_EXPORT_EXT}`)
    }
}

function triggerBlobDownload(blob: Blob, fileName: string) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.rel = 'noopener'
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
}


function transliterate(str: string) {
    const replacements = {
        'а': 'a', 'А': 'a',
        'б': 'b', 'Б': 'b',
        'в': 'v', 'В': 'v',
        'г': 'g', 'Г': 'g',
        'д': 'd', 'Д': 'd',
        'е': 'e', 'Е': 'e',
        'ё': 'e', 'Ё': 'e',
        'ж': 'zh', 'Ж': 'zh',
        'з': 'z', 'З': 'z',
        'и': 'i', 'И': 'i',
        'й': 'y', 'Й': 'y',
        'к': 'k', 'К': 'k',
        'л': 'l', 'Л': 'l',
        'м': 'm', 'М': 'm',
        'н': 'n', 'Н': 'n',
        'о': 'o', 'О': 'o',
        'п': 'p', 'П': 'p',
        'р': 'r', 'Р': 'r',
        'с': 's', 'С': 's',
        'т': 't', 'Т': 't',
        'у': 'u', 'У': 'u',
        'ф': 'f', 'Ф': 'f',
        'х': 'h', 'Х': 'h',
        'ц': 'c', 'Ц': 'c',
        'ч': 'ch', 'Ч': 'ch',
        'ш': 'sh', 'Ш': 'sh',
        'щ': 'sch', 'Щ': 'sch',
        'ъ': '', 'Ъ': '',
        'ы': 'y', 'Ы': 'y',
        'ь': '', 'Ь': '',
        'э': 'e', 'Э': 'e',
        'ю': 'yu', 'Ю': 'yu',
        'я': 'ya', 'Я': 'ya',
        'і': 'i', 'І': 'i',
        'ї': 'yi', 'Ї': 'yi',
        'є': 'e', 'Є': 'e',
    } as const
    for (const [key, value] of Object.entries(replacements)) {
        str = str.replaceAll(key, value)
    }
    return str.replace(/[^a-zA-Z0-9]/g, '_')

}

/** Сжатие gzip через CompressionStream (Chromium, Firefox, Safari 16.4+). */
async function gzipUtf8Text(text: string): Promise<Blob> {
    const stream = new Blob([text]).stream().pipeThrough(new CompressionStream('gzip'))
    return new Response(stream).blob()
}
